<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>